import '../styles/screening.css';
import { Button } from 'antd';
import i18n from 'i18next';

export const LanguageSwitcher = () => {
  const oppositeLanguage = i18n.language === 'nl' ? 'en' : 'nl';
  const translateText =
    oppositeLanguage === 'en'
      ? 'Translate to English'
      : 'Vertaal naar het Nederlands';

  const handleClick = async () => {
    await i18n.changeLanguage(oppositeLanguage);
  };

  return (
    <Button className="screening-language-switcher" onClick={handleClick}>
      {translateText}
    </Button>
  );
};
